import {
  Controller,
  Control,
  FieldValues,
  DeepMap,
  FieldError,
  RegisterOptions,
} from 'react-hook-form';
import TextField from '@mui/material/TextField';
import { Tooltip } from '@mui/material';

interface TextInputProps {
  label: string;
  name: string;
  control: Control;
  required?: boolean;
  errors?: DeepMap<FieldValues, FieldError>;
  rules?: Exclude<
    RegisterOptions,
    'valueAsNumber' | 'valueAsDate' | 'setValueAs'
  >;
  type?: string;
  inputProps?: any;
  defaultValue?: any;
  className?: string;
  multiline?: boolean;
  disabled?: boolean;
  tooltip?: string;
}

export default function TextInput({
  label,
  name,
  control,
  required = false,
  errors,
  rules = undefined,
  type = 'text',
  inputProps = undefined,
  defaultValue = undefined,
  className = undefined,
  multiline = false,
  disabled = false,
  tooltip = '',
}: TextInputProps) {
  return (
    <Controller
      name={name as any}
      control={control}
      defaultValue={defaultValue || ''}
      rules={rules}
      render={({ field }) => (
        <Tooltip title={tooltip || ''} placement="bottom">
          <TextField
            className={className}
            {...field}
            label={label}
            multiline={multiline}
            required={required}
            variant="filled"
            helperText={errors ? errors[name]?.message : undefined}
            type={type}
            inputProps={inputProps}
            error={errors ? !!errors[name] : false}
            disabled={disabled}></TextField>
        </Tooltip>
      )}
    />
  );
}
